__turbopack_context__.v({
  "findMySizeModal": "Measure-module-scss-module__e66uiq__findMySizeModal",
  "mainMeasure": "Measure-module-scss-module__e66uiq__mainMeasure",
  "modal": "Measure-module-scss-module__e66uiq__modal",
  "sizeGuideButton": "Measure-module-scss-module__e66uiq__sizeGuideButton",
  "textAlignCentre": "Measure-module-scss-module__e66uiq__textAlignCentre",
});
